/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{RenderingContext as e}from"../../../webgl/RenderingContext.js";class t extends e{constructor(e,t,n){super(e,t),this.newCache=n}}export{t as RenderingContext};
